import BankAccountModal from './BankAccountModal.vue';

export default BankAccountModal;
